import { render, staticRenderFns } from "./MessagesPage.vue?vue&type=template&id=6427bcba&"
import script from "./MessagesPage.vue?vue&type=script&lang=js&"
export * from "./MessagesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports